import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { Modal } from 'carbon-components-react';
import { FormField } from '../formfield/formfield.component';
import flatten from '../util/flatten';
import Loading from '../loading/loading.component';
import { RecaptchaService } from '../services/recaptcha.service';

@inject('appStore', 'routerStore', 'emailLinkForm')
@observer
export default class EmailLinkModal extends Component {
    @observable open = false;

    recaptchaService;

    constructor(props) {
        super(props);
        this.recaptchaService = new RecaptchaService(props.appStore);
    }

    async onSubmit(e) {
        e.preventDefault();
        const { emailLinkForm } = this.props;

        const isValid = await this.recaptchaService.validateRecaptcha();
        if (isValid) {
            await emailLinkForm.submit(e);
        }
    }

    /**
     * close email report modal
     * remove overflow class from body
     * reset appStore emailLink observables
     */
    closeModal() {
        const { appStore } = this.props;

        this.open = false;
        document.body.classList.remove('ht-modal-open');

        // wait until modal has closed before resetting
        setTimeout(() => {
            appStore.emailLinkSuccess = false;
            appStore.emailLinkLoading = false;
            appStore.emailLinkError = false;
        }, 500);
    }

    /**
     * open email report modal
     * add overflow class from body
     * call callback if provided
     */
    openModal() {
        const { onOpenCallback } = this.props;
        this.open = true;

        document.body.classList.add('ht-modal-open');

        if (onOpenCallback) {
            onOpenCallback();
        }
    }

    closeButton() {
        return (
            <button
                type='button'
                className='ht-button'
                onClick={() => this.closeModal()}
            >
                Close
            </button>
        );
    }

    /**
     * Refreshes the page to renew the securityID for the form
     */
    refreshPage() {
        location.reload();
    }

    refreshButton() {
        return (
            <button
                type='button'
                className='ht-button'
                onClick={() => this.refreshPage()}
            >
                Refresh
            </button>
        );
    }

    /**
     * render the form for the modal
     */
    renderForm() {
        const { emailLinkForm, appStore } = this.props;
        const errors = emailLinkForm.errors();

        return (
            <>
                <div className='ht-modal-intro'>
                    <p>Provide your email address to receive a link to the tool with all the data you added during this visit.</p>
                    <p>You can use this link to return to the tool and complete your heating assessment within 60 days. Please make sure you complete the tool and print a copy of the report for your records.</p>
                    <p>After 60 days your data will be cleared, and you’ll need to return to the tool and start again.</p>
                </div>
                <form className='ht-form' onSubmit={(e) => this.onSubmit(e)}>
                    {emailLinkForm.map((field) => {
                        field.errors = errors[field.path];
                        return (
                            <FormField
                                key={field.id}
                                field={field}
                                formValues={flatten(emailLinkForm.values())}
                            />
                        );
                    })}
                    <input type='hidden' name='securityID' value={appStore.sectoken} />
                    <button type='submit' className='ht-button'>
                        {appStore.emailLinkLoading ? 'Submitting...' : 'Email link'}
                    </button>
                </form>
            </>
        );
    }

    renderSuccess() {
        const { appStore } = this.props;

        return (
            <div className='ht-result-report-success'>
                <p>A link to the Heating Assessment Tool, with all your data has been sent to {appStore.emailLinkSuccess}</p>
                <p>{this.closeButton()}</p>
            </div>
        );
    }

    renderError() {
        const { appStore } = this.props;

        return (
            <div className='ht-result-report-error'>
                {appStore.emailLinkError &&
                    <>
                        <p>{appStore.emailLinkError.message}</p>
                        {appStore.emailLinkError.code === 405 ? (
                            <div>{this.refreshButton()}</div>
                        ) : (
                            <div>{this.closeButton()}</div>
                        )}
                    </>}
                {(appStore.captchaVerificationError || appStore.isCaptchaVerified === false) &&
                    <>
                        <p>{appStore.captchaVerificationError}</p>
                        <div>{this.refreshButton()}</div>
                    </>}
            </div>
        );
    }

    render() {
        const { appStore } = this.props;

        let heading, content;

        if (appStore.emailLinkLoading) {
            heading = '';
            content = <Loading />;
        } else if (appStore.emailLinkSuccess) {
            heading = 'Thank you';
            content = this.renderSuccess();
        } else if (appStore.emailLinkError || appStore.captchaVerificationError) {
            heading = '';
            content = this.renderError();
        } else {
            heading = 'Your Heating Capacity report';
            content = this.renderForm();
        }

        return (
            <Modal
                open={this.open}
                id='email-report-modal'
                className='ht-modal'
                modalHeading={heading}
                modalAriaLabel={heading}
                passiveModal
                danger={false}
                onRequestClose={() => this.closeModal()}
            >
                {content}
            </Modal>
        );
    }
}
